import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { api } from '@api';
import { mainLeadsActionsPack } from '@leads/actions';
import { openUpdateLeadFormDrawer } from '@leads/components/forms';
import { mainLeadsSelectorsPack } from '@leads/selectors';
import { IAppState } from '@store';
import { LeadsHeader as XLeadsHeader, LeadsHeaderProps as XLeadsHeaderProps } from './header.view';

export type LeadsHeaderProps = {
	invalidateLeads?: typeof mainLeadsActionsPack.actions.invalidateLeads;
	setDateRange?: typeof mainLeadsActionsPack.actions.setDateRange;
} & Partial<Pick<XLeadsHeaderProps, 'dateRange' | 'isFetching' | 'isFetchingNewLeadSmsText'>>;

const LeadsHeader: React.SFC<LeadsHeaderProps> = props => {
	const { dateRange, invalidateLeads, isFetching, isFetchingNewLeadSmsText, setDateRange, ...rest } = props;

	const handleAddLead = () =>
		openUpdateLeadFormDrawer({
			appearance: 'add',
			lead: {
				...new api.leadsPack.security.package.Lead(),
				Status: {
					CLASSIFIER: 'CODE_NATURAL_KEY',
					Code: '',
					CopySupportingElement: false,
					GUID: '',
					ID: -1,
					Name: '',
					PACKAGE: 'CORE',
				},
			},
		});

	return (
		<XLeadsHeader
			{...rest}
			dateRange={dateRange}
			isFetching={isFetching}
			isFetchingNewLeadSmsText={isFetchingNewLeadSmsText}
			onAddLead={handleAddLead}
			onRequestUpdateLeads={invalidateLeads}
			onSetDateRange={setDateRange}
		/>
	);
};

LeadsHeader.defaultProps = {};
LeadsHeader.displayName = 'LeadsHeader';

function mapStateToProps(state: IAppState): Partial<LeadsHeaderProps> {
	return {
		dateRange: mainLeadsSelectorsPack.selectDateRange(state),
		isFetching: mainLeadsSelectorsPack.selectAsyncLeads.selectIsFetching(state),
		isFetchingNewLeadSmsText: mainLeadsSelectorsPack.selectAsyncNewLeadSmsText.selectIsFetching(state),
	};
}

function mapDispatchToProps(dispatch: Dispatch) {
	return bindActionCreators(
		{
			invalidateLeads: mainLeadsActionsPack.actions.invalidateLeads,
			setDateRange: mainLeadsActionsPack.actions.setDateRange,
		},
		dispatch,
	);
}

export default connect<any, any, LeadsHeaderProps>(mapStateToProps, mapDispatchToProps)(LeadsHeader);
